export enum TutorialSteps {
  WELCOME = 0,
  TUTORIAL_FLEET_AMOUNT,
  TUTORIAL_FLEET_PRE_TRANSACTION,
  SUGGESTION_PROFILE,
}
